<template>
  <div>
    <!--Issue has been resolved-->
    <!--<v-alert type="info" prominent class="text-left">-->
    <!--  We have had a few problems with our login system recently. We believe that we have rectified this eissue and apologise for any inconvenience this has caused. Please feel free to reach out to us if you run into any other problems with logging in or otherwise.-->
    <!--</v-alert>-->

    <v-card v-if="showForm">
      <!-- <v-toolbar color="secondary" class="primary--text" dark flat> -->
      <v-toolbar color="primary" class="secondary--text" dark flat>
        <v-toolbar-title class="headline">Reset Password</v-toolbar-title>
      </v-toolbar>
      <br>
      <p v-if="account">Account: {{ account }}<br></p>
      <span v-if="username">Reset password for user<br>{{ username }}</span>
      <v-card-text>
        <v-form ref="resetForm">
          <!--          <v-text-field-->
          <!--              @click:append="showPassword = !showPassword"-->
          <!--              @keyup.enter="login()"-->
          <!--              v-model="password"-->
          <!--              id="password"-->
          <!--              label="New Password"-->
          <!--              prepend-icon="mdi-lock"-->
          <!--              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"-->
          <!--              :type="showPassword ? 'text': 'password'"-->
          <!--              :rules="[rules.required]"-->
          <!--              color="secondary"-->
          <!--              required-->
          <!--          />-->
          <v-text-field
            v-model="password"
            id="password"
            label="New Password"
            prepend-icon="mdi-lock"
            type="password"
            :rules="[rules.required]"
            color="secondary"
            required
          />
          <transition name="fade">
            <v-text-field
              @keyup.enter="changePassword"
              v-model="confirmPassword"
              id="password"
              label="Confirm Password"
              prepend-icon="mdi-lock"
              type="password"
              :rules="[passwordsMatchRule]"
              color="secondary"
              required
            />
          </transition>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <!--        <Spinner :active='isLoading' :full-page='fullPage' />-->
        <!--        <v-btn @click="$refs.resetForm.reset()" color="red" outlined>Clear</v-btn>-->
        <v-btn @click="changePassword" :disabled="!passwordsMatchState" color="secondary" class="primary--text">Change Password</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-toolbar color="primary" class="secondary--text" dark flat>
        <v-toolbar-title class="headline">Reset Password</v-toolbar-title>
      </v-toolbar>
    </v-card>

    <v-alert
      v-model="alertState"
      :color="isError ? 'red' : 'green'"
      class="mt-3"
      dark
      dismissible>
      <span v-if="Array.isArray(alertMessage)">
        <span v-for="(message, idx) in alertMessage" :key="idx"> {{ message }} <br v-if="idx!==alertMessage.length"></span>
      </span>
      <span v-else>
        {{ alertMessage }}
      </span>
    </v-alert>
  </div>
</template>

<script>

// const DOMAIN = 'http://localhost:8081/'
// const DOMAIN = 'https://auth-97f6c.appspot.com/'
const DOMAIN = process.env.VUE_APP_API_ROOT

export default {
  name: 'Login',
  data: () => ({
    username: '',
    account: '',
    password: '',
    confirmPassword: '',
    showPassword: false,
    match: false,
    alertState: false,
    isError: false,
    alertMessage: '',
    showForm: false,
    isLoading: false,
    rules: {
      required: value => !!value || 'Required.',
    }
  }),
  computed: {
    passwordsMatchState() {
      return this.password && this.password === this.confirmPassword
    },
    passwordsMatchRule() {
      if (this.password === '' || this.confirmPassword.length > this.password.length) {
        return 'Passwords do not match'
      }
      return this.password.slice(0, this.confirmPassword.length) === this.confirmPassword || 'Passwords do not match'
    }
  },
  async mounted() {
    // Confirm reset link is good before continuing
    // Display user and account
    const user = await this.validateLink()
    if (user) {
      this.showForm = true
      this.username = user.username
      this.account = user.account
      return
    }
    //! display invalid navigation with link to login
    this.showForm = false
  },
  methods: {
    async validateLink() {
      const url = DOMAIN + 'resetLink'
      const method = 'POST'
      const mode = 'cors'
      const credentials = 'include'
      const headers = {
        'content-type': 'application/json'
      }
      const resetCode = this.$route.query.resetCode
      if (!resetCode) {
        return null
      }
      const body = JSON.stringify({ resetCode, validate: true })
      this.isError = false
      this.alertState = false
      this.isLoading = true

      let response, status
      try {
        // const t0 = performance.now()
        response = await fetch(url, { method, mode, credentials, headers, body })
        // console.log(`login done: ${performance.now() - t0}`)
        status = response.status
        response = await response.json()
      } catch (e) {
        this.alertMessage = 'There was an error contacting the login server. If the problem continues please contact Nettex for assistance.'
        this.isError = true
        this.alertState = true
        return console.log(e)
      } finally {
        this.isLoading = false
      }
      let retObj
      if (status === 200) {
        retObj = { username: response.username, account: response.account }
      } else {
        console.log(`Status: ${status} | Reset code validation failed`)
        console.log(`Error: ${response.message}`)
        this.alertMessage = response.message.split('\n')
        this.isError = !response.successful
        this.alertState = true
        retObj = null
      }
      return retObj
    },
    async changePassword() {
      const url = DOMAIN + 'resetLink'
      const method = 'POST'
      const mode = 'cors'
      const credentials = 'include'
      const headers = {
        'content-type': 'application/json',
        // 'x-auth-cookie': document.cookie
      }
      const resetCode = this.$route.query.resetCode
      const password = this.password
      if (!resetCode) {
        return null
      }
      const body = JSON.stringify({ resetCode, password })
      this.isError = false
      this.alertState = false
      this.isLoading = true

      let response, status
      try {
        // const t0 = performance.now()
        response = await fetch(url, { method, mode, credentials, headers, body })
        // console.log(`login done: ${performance.now() - t0}`)
        status = response.status
        response = await response.json()
      } catch (e) {
        this.alertMessage = 'There was an error contacting the login server. If the problem continues please contact Nettex for assistance.'
        this.isError = true
        this.alertState = true
        return console.log(e)
      } finally {
        this.isLoading = false
      }
      if (status === 200) {
        this.alertMessage = response.message
        this.isError = false
        this.alertState = true
        const origin = window.location.origin.split('accounts')[1] || '.nettex.com.au'
        setTimeout(function () { window.location = `https://accounts${origin}/login` }, 3000)
      } else {
        console.log(`Change password attempt failed! Status: ${status} | Error: ${response.message}`)
        this.alertMessage = response.message
        this.isError = !response.successful
        this.alertState = true
      }
    }
  }
}
</script>
